import axios, { AxiosInstance } from "axios";
import url from "../server";

let accessToken: string | null;

const api: AxiosInstance = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

// 요청
api.interceptors.request.use(
  async (config) => {
    const token = await tokenReturn();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 ||
      (error.response?.status === 403 && !originalRequest._retry)
    ) {
      originalRequest._retry = true; // 무한 루프 방지

      const newToken = await refresh();
      if (newToken) {
        // console.log("새 토큰: ", newToken);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest); // 갱신된 토큰으로 재요청
      } else {
        console.log("토큰발급실패");
      }
    }
    return Promise.reject(error);
  }
);

/** 토큰 검사 */
const tokenReturn = async (): Promise<string | null> => {
  let token = accessToken;
  if (!token) {
    // console.log("리프레시 작똥");
    token = await refresh();
  }
  if (!token) {
    alert("로그인이 만료되었습니다. 재로그인 해주세요.");
    logout();
    return null;
  }
  return token;
};

/** 토큰 재발급 */
const refresh = async (): Promise<string | null> => {
  const refreshToekn = localStorage.getItem("key") || null;
  if (!refreshToekn) {
    return null;
  }
  try {
    const res = await axios.post(
      url.Communication_url.refresh,
      { refreshToken: refreshToekn },
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }
    );
    const newAccessToken = res.data.accessToken;
    accessToken = newAccessToken;
    return newAccessToken;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const errRes = err.response?.data;
      console.log(errRes);
    } else {
      console.log(err);
    }
    return null;
  }
};

/** 로그아웃  */
const logout = (isAmdin?: string) => {
  accessToken = null;
  localStorage.removeItem("key");
  localStorage.removeItem("authority");
  if (isAmdin) {
    window.location.href = "/admin/login";
  } else {
    window.location.href = "/";
  }
};

export default api;
